import saasApi from "../../utils/saasApi";
import { normalizeCameraHealth, normalizeIncidentFromAlert } from "../adapters/platformAdapters";

export const platformRealService = {
  getOverview: async () => {
    const [dashboard, cameras, health] = await Promise.all([
      saasApi.getDashboard().catch(() => null),
      saasApi.getCameras().catch(() => ({ cameras: [] })),
      saasApi.getHealth().catch(() => null),
    ]);
    return { dashboard, cameras: cameras.cameras || [], health };
  },
  getCameraHealth: async () => {
    const payload = await saasApi.getCameras();
    return (payload.cameras || []).map(normalizeCameraHealth);
  },
  getIncidentsFromAlerts: async (params = {}) => {
    const alerts = await saasApi.getAlerts(params).catch(() => []);
    return alerts.map(normalizeIncidentFromAlert);
  },
};

